import formatWithOptions from 'date-fns/fp/formatWithOptions';
import { useLocale } from '../stores/locale';

export const toInputDate = formatWithOptions(
  { locale: useLocale.getState().dateLocale },
  'yyyy-MM-dd'
);
